import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {BrokerLoadCarrierCompanyModel} from '../../../../services/broker/model/brokerLoadCarrierCompanyModel';
import {PageableResponse} from '@common/_models/core.models';
import {BrokerUserProfile} from '../../../../services/broker/model/brokerUserProfile';
import {FileDto} from '../../../../services/broker/model/fileDto';

@Injectable({
    providedIn: 'root'
})

export class DictionariesService {
    private brokerUrl = `${environment.apiUrl}/broker`;

    constructor(
        private httpClient: HttpClient
    ) {
    }

    getAuthUserProfile(): Observable<BrokerUserProfile> {
        const url = `${this.brokerUrl}/user`;
        return this.httpClient.get<BrokerUserProfile>(url);
    }

    uploadFile(file: File): Observable<FileDto> {
        const url = `${this.brokerUrl}/storage/upload`;
        return this.httpClient.post<FileDto>(url, file);
    }

    searchCarrier(value: number): Observable<BrokerLoadCarrierCompanyModel> {
        const url = `${this.brokerUrl}/carrier/company/get/${value}`;
        return this.httpClient.get<BrokerLoadCarrierCompanyModel>(url);
    }

    searchUnit(value: string, urlEnd: string): Observable<PageableResponse<string>> {
        const url = `${this.brokerUrl}/carrier/${urlEnd}`;
        return this.httpClient.post<PageableResponse<string>>(url, {value});
    }
}
